import { abPlugin } from "@webplatform/asbis-ui";
import Vue from "vue";
Vue.config.ignoredElements = [
  "swiper-container",
  "swiper-slide",
  "sl-tab",
  "sl-tab-group",
  "sl-tab-panel"
];
function asbis_ui_default({ $gsap, $ScrollTrigger }) {
  Vue.use(abPlugin, {
    gsap: $gsap,
    ScrollTrigger: $ScrollTrigger
  });
}
export {
  asbis_ui_default as default
};
